import PropTypes from 'prop-types';
import './EnergyMark.css'; // Create a CSS file for styling

const EnergyMark = ({ mark }) => {
  const colors = {
    A2020: '#3a9c2d', // Green
    A2015: '#51ad45', // Green
    A2010: '#6EC064', // Green
    A: '#6EC064', // Green
    B: '#B5C334', // Light Green
    C: '#F7B731', // Yellow
    D: '#F39C12', // Orange
    E: '#E74C3C', // Red
    F: '#C0392B', // Dark Red,
    G: '#C0392B',
    '?': '#7F8C8D', // Gray
  };

  const color = colors[mark] || '#7F8C8D'; // Default to gray if mark is invalid
  if (!mark) return null;
  return (
    <>
      <div
        style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}
      >
        <div className="energy-mark" style={{ backgroundColor: color }}>
          <span className="energy-mark-letter">{mark}</span>
        </div>
        <div className="energy-mark-hat" style={{ borderLeftColor: color }} />
      </div>
    </>
  );
};

EnergyMark.propTypes = {
  mark: PropTypes.string.isRequired,
};

export default EnergyMark;
